export const CREATED = 'CREATED';
export const LIVE = 'LIVE';
export const ENDED = 'ENDED';